





























import { Component, Prop } from 'vue-property-decorator'

import { UseFields } from '../../../../../../../../Pi'
import { FieldData, SelectOptionData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { CheckLimitedSubscriptionNode } from '../../logic/CheckLimitedSubscriptionNode'

@Component
export default class CheckLimitedSubscriptionSidebar extends UseFields {
  @Prop() node!: CheckLimitedSubscriptionNode

  @Prop() editor!: CustomEditor

  get targets(): Array<SelectOptionData> {
    return this.node.nodeProps.targets().map((t) => {
      return {
        label: t.title,
        value: t.id
      }
    })
  }

  setTarget(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setTarget(val)
    return arg
  }

  setOffset(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.setOffset(val)
    return arg
  }
}
